<template>
  <page pageName="about">
    <v-row class="px-0 pt-12">
      <v-col>
        <h1 class="center--text gm-darkblue--text">About Us</h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="px-0 py-0">
        <div class="d-flex highlight-img"></div>
      </v-col>

      <v-col cols="12" class="overview-content px-0 py-0">
        <v-row class="d-none d-sm-flex px-12">
          <v-col cols="7">
            <v-card elevation="6">
              <v-card-title class="center--text gm-darkblue gm-whitish--text">
                <h3>Profile</h3>
              </v-card-title>
              <v-card-text>
                <p>
                  Green masters Ltd is a Nigerian company that specialises in design,
                  building, and development of infrastructure, marine works, bridges,
                  buildings, roads, highways, EPC contracts, and other civil works.
                </p>

                <p>
                  Since its incorporation, GML is a fast rising indigenous company that
                  has become one of the leading contractors in Southern and Eastern part of
                  Nigeria primarily due to the quality of our completed works.
                </p>

                <p>
                  We have delivered projects for both public and private sector clients
                  including the Port Harcourt refinery, Anambra Imo River Basin, Border
                  Communities, Federal Government Colleges in both Ebonyi and Enugu state
                  Respectively.
                </p>

                <p>
                  Our reputation for completing projects on time and within budget is widely
                  spread in the region.
                </p>

                <p>
                  Green Masters is proud to have been involved in contributing to the ground
                  breaking civil projects in Nigeria over the past few years.
                </p>

                <p>
                  These include overhauling critical infrastructure routes up to international
                  standards including medians, walkways and rehabilitation of drainage systems,
                  roads, retaining walls, supply and maintenance throughout the state, helping
                  to create a more amenable environment for the citizens while encouraging growth
                  and development in the state.
                </p>

                <p>
                  We have executed numerous Rehabilitation jobs which
                  have included buildings, rehabilitation of ballast storage tank for Port Harcourt
                  Refinery and other decommissioned projects transform the industry in the region.
                </p>

                <p>
                  Management team is made up of a group of well trained home grown Engineers across
                  the different part of the cointry. Each one brings with them years of experience
                  and a passion for excellence in the industry.
                </p>

                <p>
                  Our projects stand as proof of the quality of work we are committed to perform.
                  This is who we are; this is what we stand for.
                </p>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="5">
            <v-row>
              <v-col cols="12">
                <v-card elevation="6">
                  <v-card-title class="center--text  gm-blue gm-whitish--text">
                    <h3>Our Vision</h3>
                  </v-card-title>
                  <v-card-text>
                    <p>
                      To provide the most compelling value in the Construction industry.
                      Value, as defined by our customers, means designing and installing
                      the highest quality in construction systems, on time, safely, with
                      high customer satisfaction, at a competitive cost.
                    </p>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12">
                <v-card elevation="6">
                  <v-card-title class="center--text  gm-blue gm-whitish--text">
                    <h3>Our Mission</h3>
                  </v-card-title>
                  <v-card-text>
                    <p>
                      By providing unparalleled value, we aim to greatly accelerate the adoption
                      of our unique services in areas concerning construction.
                      This will give our customers, our communities, and our nation clean, abundant,
                      low-cost, distributed, and safe infrastructure, and will allow us to provide
                      financial security for all shareholders while giving back to the community.
                    </p>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row class="d-sm-none d-flex px-4">
          <v-col cols="12">
            <v-card elevation="6">
              <v-card-title class="center--text gm-darkblue gm-whitish--text">
                <h3>About Us</h3>
              </v-card-title>
              <v-card-text>
                <p>
                  Green masters Ltd is a Nigerian company that specialises in design,
                  building, and development of infrastructure, marine works, bridges,
                  buildings, roads, highways, EPC contracts, and other civil works.
                </p>

                <p>
                  Since its incorporation, GML is a fast rising indigenous company that
                  has become one of the leading contractors in Southern and Eastern part of
                  Nigeria primarily due to the quality of our completed works.
                </p>

                <p>
                  We have delivered projects for both public and private sector clients
                  including the Port Harcourt refinery, Anambra Imo River Basin, Border
                  Communities, Federal Government Colleges in both Ebonyi and Enugu state
                  Respectively.
                </p>

                <p>
                  Our reputation for completing projects on time and within budget is widely
                  spread in the region.
                </p>

                <p>
                  Green Masters is proud to have been involved in contributing to the ground
                  breaking civil projects in Nigeria over the past few years.
                </p>

                <p>
                  These include overhauling critical infrastructure routes up to international
                  standards including medians, walkways and rehabilitation of drainage systems,
                  roads, retaining walls, supply and maintenance throughout the state, helping
                  to create a more amenable environment for the citizens while encouraging growth
                  and development in the state.
                </p>

                <p>
                  We have executed numerous Rehabilitation jobs which
                  have included buildings, rehabilitation of ballast storage tank for Port Harcourt
                  Refinery and other decommissioned projects transform the industry in the region.
                </p>

                <p>
                  Management team is made up of a group of well trained home grown Engineers across
                  the different part of the cointry. Each one brings with them years of experience
                  and a passion for excellence in the industry.
                </p>

                <p>
                  Our projects stand as proof of the quality of work we are committed to perform.
                  This is who we are; this is what we stand for.
                </p>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" class="mt-12">
            <v-row>
              <v-col cols="12" class="mt-12">
                <v-card elevation="6">
                  <v-card-title class="center--text  gm-blue gm-whitish--text">
                    <h3>Our Vision</h3>
                  </v-card-title>
                  <v-card-text>
                    <p>
                      To provide the most compelling value in the Construction industry.
                      Value, as defined by our customers, means designing and installing
                      the highest quality in construction systems, on time, safely, with
                      high customer satisfaction, at a competitive cost.
                    </p>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12">
                <v-card elevation="6">
                  <v-card-title class="center--text  gm-blue gm-whitish--text">
                    <h3>Our Mission</h3>
                  </v-card-title>
                  <v-card-text>
                    <p>
                      By providing unparalleled value, we aim to greatly accelerate the adoption
                      of our unique services in areas concerning construction.
                      This will give our customers, our communities, and our nation clean, abundant,
                      low-cost, distributed, and safe infrastructure, and will allow us to provide
                      financial security for all shareholders while giving back to the community.
                    </p>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <business-areas-highlight />
  </page>
</template>

<script>

export default {
  name: 'about',

  data: () => ({

  })
}
</script>

<style scoped>
.highlight-img {
  width: 100vw;
  height: 30vh;
  background-image: url('../assets/images/about/about-us.jpg');
  background-attachment: fixed;
  background-position: 50% 0%;
  background-repeat: no-repeat;
  background-size: cover;
}

.overview-content {
  transform: translateY(-32px);
}
</style>
